// Recommendation entries that are only a prefix (e.g. "Jeg har aldri ") and
// must not be added to a room without the user completing them.
export const BLOCKED_REC_INDICES = [
  0, 1, 2, 3, 4, 6, 7, 8, 9, 10, 11, 12, 14, 15, 16,
];

export function getBlockedSuggestions(t) {
  const recs = t("rec", { returnObjects: true }) || [];
  return BLOCKED_REC_INDICES.map((i) => recs[i]?.text).filter(Boolean);
}
